import {createSlice} from '@reduxjs/toolkit';
//import {lightTheme} from '~/theme/themeColors';
import {format} from 'date-fns';

const initialState = {
  language: 'DE',
  themeApp: 'white',
  displayTab: 'flex',
  colors: 'lightTheme',
  hasCheckedMaintenance: false,
  lastMaintenanceCheck: null,
  hasLocationPermission: false,
  hasNotificationPermission: false,
  messageHeader: '',
  typeNotification: '',
  activeMessageHeader: false,
  activeErrorPage: false,
  activeCalendar: false,
  animOpenCalendar: 'translateY(100%)',
  calendarDisable: false,
  dateCalendar: format(new Date(), 'dd-MM-yyyy'),
  dateChoose: '',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleLanguage: (state, action) => {
      state.language = action.payload;
    },
    toggleTheme: (state, action) => {
      return {
        ...state,
        themeApp: action.payload.themeApp,
        colors: action.payload, // salva o objeto inteiro se quiser
      };
    },
    toggleDisplayTab: (state, action) => {
      state.displayTab = action.payload;
    },
    setHasCheckedMaintenance: (state, action) => {
      // NOVO
      state.hasCheckedMaintenance = action.payload;
    },
    TOGGLE_CALENDAR: (state, action) => {
      state.activeCalendar = action.payload;
    },
    MESSAGE_HEADER: (state, action) => {
      const {activeMessageHeader, typeNotification, messageHeader} = action.payload;
      state.activeMessageHeader = activeMessageHeader;
      state.typeNotification = typeNotification;
      state.messageHeader = messageHeader;
    },
    
    TOGGLE_ERROR_PAGE: (state, action) => {
      const {activeErrorPage} = action.payload;
      state.activeErrorPage = activeErrorPage;
    },
    TOGGLE_CALENDAR_ANIM: (state, action) => {
      const {animOpenCalendar, calendarDisable } = action.payload;
      state.animOpenCalendar = animOpenCalendar
      state.calendarDisable = calendarDisable
    },
   
  },
});

export const {
  toggleLanguage,
  toggleTheme,
  toggleDisplayTab,
  setHasCheckedMaintenance,
  setLastMaintenanceCheck,
  setHasLocationPermission,
  setHasNotificationPermission,
  TOGGLE_ERROR_PAGE,
  MESSAGE_HEADER,
  TOGGLE_CALENDAR,
  TOGGLE_CALENDAR_ANIM
} = appSlice.actions;
export default appSlice.reducer;
